
import React from 'react';
import { Users } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { TeamSelector } from '@/components/team-details/TeamSelector';

export const TeamDetailsCard: React.FC = () => {
  return (
    <Card className="hover:shadow-lg transition-shadow w-full h-full">
      <CardHeader className="text-center">
        <Users className="w-24 h-24 mx-auto mb-4" />
        <CardTitle className="text-2xl">Team Details</CardTitle>
        <CardDescription className="text-lg">
          Explore individual team statistics and performance
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col">
        <TeamSelector currentTeam="" />
      </CardContent>
    </Card>
  );
};

export default TeamDetailsCard;
